import { MemberListReport } from "../../components/report";

export default function MemberListDead() {
  return <MemberListReport variant="dead" />;
}
